import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useUk } from '../../../../../hooks'
import Button from '../../../../Button'
import {
  FormBody,
  FormFieldsContainer,
  useFormValidationErrorsNotification,
} from '../../../../Form'
import {
  REGISTRATION_FORM_FIELD_HEIGHT,
  REGISTRATION_FORM_FIELD_NAME_BUILDING,
  REGISTRATION_FORM_FIELD_NAME_FLAT,
} from '../RegistrationForm.constants'

import { BuildingField } from './BuildingField'
import { EmailField } from './EmailField'
import { FirstNameField } from './FirstNameField'
import { FlatField } from './FlatField'
import { LastNameField } from './LastNameField'

import * as styles from './RegistrationFormFields.module.css'

function RegistrationFormFields({ onRemoveNotification, onSetNotification }) {
  const { isSubmitting, setFieldValue, values } = useFormikContext()

  const { t } = useTranslation()

  const uk = useUk()

  const flatSelectStatesRef = useRef(null)

  const buildingId = values[REGISTRATION_FORM_FIELD_NAME_BUILDING]?.value

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  function handleClearBuilding() {
    setFieldValue(REGISTRATION_FORM_FIELD_NAME_FLAT, null)

    flatSelectStatesRef.current?.handleClearSearch()
  }

  return (
    <FormBody Actions={null} Header={null}>
      <FormFieldsContainer className={styles.formFields}>
        <FirstNameField disabled={isSubmitting} />
        <LastNameField disabled={isSubmitting} />
        <EmailField disabled={isSubmitting} />
        <BuildingField
          disabled={isSubmitting}
          ukId={uk.id}
          onClear={handleClearBuilding}
        />
        <FlatField
          buildingId={buildingId}
          disabled={isSubmitting}
          selectStatesRef={flatSelectStatesRef}
          ukId={uk.id}
        />
      </FormFieldsContainer>
      <Button.Contained
        className={styles.button}
        height={REGISTRATION_FORM_FIELD_HEIGHT}
        isLoading={isSubmitting}
        text={t('Auth.SignUpSubmitBtnKey')}
        type='submit'
      />
    </FormBody>
  )
}

export default RegistrationFormFields
